// extracted by mini-css-extract-plugin
export default {"navlink":"Sidebar_navlink__QOmgP","active":"Sidebar_active__KLLVf","icon":"Sidebar_icon__bbxcL"};